/// <reference path="../HTML/Box/Login/FacebookLoginBox.ts" />
/// <reference path="./Service.ts" />
namespace HA.Core.Service {
    import FacebookLoginBox = HA.Core.HTML.FacebookLoginBox;
    import Tag = HA.Core.HTML.Tag;

    export class LoginService extends Service {

        /**
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            const me = this;
            const t = new Tag(this.get("element"));
            const e = t.findElementById("facebookLogin");
            const fb = new FacebookLoginBox({
                element: e,
                onClick() {
                    me.login();
                },
            });

            const hal = t.findById("haLogin");
            hal.onClick(() => {
                location.replace(hal.getAttribute("a"));
            });

            const har = t.findById("haRegistration");
            har.onClick(() => {
                location.replace(har.getAttribute("a"));
            });

            if (fb.hasRedirection()) {
                this.addToData("redirect", fb.getRedirectionData());
            }

            this.addToData("loginBox", fb);
        }

        /**
         *
         * @returns {any}
         */
        protected getLoginData() {
            return this.get("userData");
        }

        /**
         *
         * @returns FacebookLoginBox
         */
        protected getLoginBox() {
            return this.get("loginBox");
        }

        /**
         *
         * @returns {UserService}
         */
        protected getUserService() {
            return this.getService("ha.service.user");
        }

        /**
         *
         * @returns {WebPage}
         */
        protected getPageService() {
            return this.getService("ha.service.webpage");
        }

        /**
         *
         * @returns {string}
         */
        protected getAppId() {
            return this.get("id");
        }

        /**
         * @param data
         */
        protected notifyError(data: any) {
        }

        protected login() {
            const me = this;
            const box = this.getLoginBox();

            FB.init(
                {
                    appId: box.getAppId(),
                    status: true,
                    xfbml: true,
                    version: box.getVersion(),
                });

            FB.login( (response: fb.StatusResponse) => {
                if (response.authResponse) {
                    me.submit(toMap(response.authResponse));
                }
            }, {
                scope: "public_profile,email",
            });
        }

        protected hasRedirection() {
            return this.has("redirect");
        }

        /**
         *
         * @returns {Map<any, any>}
         */
        protected getRedirectionData() {
            return toMap(this.get("redirect"));
        }

        protected submit(data: any) {
            const userService: User = this.getUserService(),
                me = this;
            userService.loginFB(data).then(
                 (data: any) => {
                    if (me.hasRedirection()) {
                        const appData = me.getRedirectionData();
                        if (appData.get("r")) {
                            window.location.reload();
                            return;
                        }
                        if (appData.get("id")) {
                            me.getPageService().setMainApp(appData);
                            me.getPageService().showApp(appData);
                        }
                    }
                    me.getPageService().removeApp(me.getAppId());
                },
            ).catch(
                (dataR: any) => {
                    me.notifyError(dataR);
                },
            );
        }
    }
}
